import { baseThunk } from "../../fetch/basicThunk";
import { QUERY_GET_TAXONOMY_DESCRIPTIONS } from '../../fetch/constantQueries';

export const getTaxonomyDescriptions = baseThunk('masters/taxonomyDescriptions', QUERY_GET_TAXONOMY_DESCRIPTIONS, "GET");